<!-- 组件说明 -->
<template>
  <a-form-model-item
    label="助教"
    :labelCol="labelCol"
    :wrapperCol="wrapperCol"
    prop="assistant"
  >
    <a @click="choocezj = !choocezj">选择助教</a>
    <a-drawer
      title="选择助教"
      width="650"
      :closable="false"
      :body-style="{ paddingBottom: '80px' }"
      :visible="choocezj"
      @close="close"
    >
      <a-table
        ref="table"
        size="small"
        :columns="columns"
        :dataSource="data"
        :rowKey="r => r.key"
        v-model="assistantList"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
      >
      </a-table>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="close">
          取消
        </a-button>
        <a-button type="primary" @click="submit">
          确定
        </a-button>
      </div>
    </a-drawer>
    <div>
      <a-tag
        v-for="(item, index) in selectionRows"
        :key="index"
        closable
        @close.prevent="closeUserTag(index)"
      >
        {{ item.name }}
      </a-tag>
    </div>
    <a-input
      :max-length="3"
      style="width: 100px;display:none"
      placeholder="请输入"
      v-model="teaform.assistant"
    ></a-input>
  </a-form-model-item>
</template>

<script>
import { courseTeacherList } from '@/api/api';
const columns = [
  {
    title: '成员姓名',
    dataIndex: 'name'
  },
  {
    title: '进群时间',
    dataIndex: 'joinTime'
  }
];
export default {
  props: ['teaform', 'groupChatId'],
  components: {},
  data() {
    return {
      columns,
      data: [],
      selectedRowKeys: [],
      selectionRows: [],
      choocezj: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      assistantTagList: [],
      assistantTagKeys: [],
      assistantList: []
    };
  },
  computed: {},
  created() {
    console.log(this.selectionRows);
  },
  methods: {
    // 取消回调
    close() {
      this.choocezj = false;
    },
    // 确认按钮回调
    submit() {
      this.assistantTagList = this.selectionRows;
      this.assistantTagKeys = this.selectedRowKeys;
      this.assistantList = this.selectedRowKeys;
      sessionStorage.setItem(
        'assistantTagList',
        JSON.stringify(this.assistantTagList)
      );
      this.choocetea = false;
      this.choocezj = false;
      this.teaform.assistant = this.selectionRows;
    },
    // 选择助教修改回调
    onSelectChange(selectedRowKeys, selectionRows) {
      console.log(selectionRows, 1111);
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    // 删除标签回调
    closeUserTag(i) {
      console.log(this.selectedRowKeys, i);
      this.selectionRows.splice(i, 1);
      this.selectedRowKeys.splice(i, 1);
      this.assistantList.splice(i, 1);
    },
    // 获取助教列表
    getTeacherList() {
      if (this.groupChatId) {
        courseTeacherList({
          chatId: this.groupChatId
        }).then(res => {
          if (res.success) {
            this.data = res.result.result;
            this.data.map(e => (e.key = e.userId));
          }
        });
      }
    }
  },
  watch: {},
  mounted() {
    this.getTeacherList();
  }
};
</script>

<style scoped></style>
